import React from "react";

import {
  Container,
  Row,
  TextSimpleMoyenBis,
  Title,
  RootHome,
  BoxRadius,
  Sign,
} from "../../Globalstyles";
import FooterComponent from "../Footer";

import iconCheck from "../../images/Check.svg";
import Logo from "../../images/logo-babilou.png";
import happyFace from "../../images/Happy.svg";

export default function SuccessComponent() {
  return (
    <>
      <RootHome>
        <Container style={{ padding: "10px" }}>
          <Row>
            <img
              src={Logo}
              style={{
                width: "160px",
                minWidth: "100px",
                margin: "50px",
              }}
              alt="logo"
            />
          </Row>
          <Row>
            <BoxRadius style={{ backgroundImage: `url(${happyFace})` }}>
              <img
                src={iconCheck}
                alt="Icone de succès"
                style={{ width: "90px", marginBottom: "50px" }}
              />
              <Title style={{ textAlign: "center" }}>
                Votre règlement a été effectué avec succès
              </Title>
              <TextSimpleMoyenBis>
                Vous allez recevoir une confirmation de votre paiement par mail.
              </TextSimpleMoyenBis>
              <TextSimpleMoyenBis>
                Vous ne l'avez pas reçue ? Vérifiez vos spams.
              </TextSimpleMoyenBis>
              <TextSimpleMoyenBis
                style={{
                  fontWeight: "700",
                }}
              >
                Les équipes Babilou
              </TextSimpleMoyenBis>
              <Sign />
            </BoxRadius>
          </Row>
        </Container>
      </RootHome>
      <FooterComponent />
    </>
  );
}
